module.exports = __webpack_public_path__ + "static/img/C (28).4173de16.png";